export enum ToastKey {
  GetUserData,
  GetBotAvatars,
  GetUserAvatars,
  UpdateUserProfileAction,
  LoadContentAction,
  GetLibFilters,
  LoadArticleAction,
  LoadMaterialsContentAction,
  AddFavorite,
  RemoveFavorite,
  AddMaterial,
  RemoveMaterial,
  LoadBackpackContentAction,
  LoadMaterialsTemplates,
  SendMaterialsAction,
  SaveJournalAction,
  UploadAttachAction,
  SendFeedbackAction,
  JoinNewsletterAction,
  LoadTranslation,
  ChangeLocale,
  GetToken,
  FetchMedia,
  GetBotList,
  GetMainDialog,
  SetDialogLanguage,
  GetXpeditionList,
  StartXpedition,
  StartInterview,
  LoadDialoguesAction,
  SetDialogueNameAction,
  LoadDialogueAction,
  CreateDialogueAction,
  RemoveDialogueAction,
  ResumeDialogue,
  LoadDialogueParticipantsAction,
  LoadDialogueParticipantAction,
  LoadBotsAction,
  LoadUsersAction,
  AddBotToDialogueAction,
  AddUsersToDialogueAction,
  AddUserToDialogueAction,
  RemoveParticipantFromDialogueAction,
  BlockParticipantAction,
  UnlockParticipantAction,
  StartXpeditionAction,
  RestartXpeditionAction,
  CreateVideoCallAction,
  GetVideoCallTokenAction,
  GetVideoCallRtmTokenAction,
  FinishVideoCallAction,
  GetVideoCallActiveAction,
  GetDialogueHistory,
  LoadXpeditionsAction,
  LoadTeiArticleAction,
  LoadTeiArticleAuthorsAction,
  LoadTeiArticleReferencesAction,
  LoadTeiArticleSectionsAction,
  LoadTeiArticleCollectionsAction,
  LoadTeiArticleTablesAction,
  LoadTeiArticleReferenceAction,
  LoadTeiReferenceAuthorsAction,
  GetResourceFilters,
  LoadTeiArticleSectionAction,
  LoadJournalsAction,
  CreateJournalAction,
  EditJournalAction,
  RemoveJournalAction,
  RemoveActivityJournalAction,
  LoadJournalStatsAction,
  LoadJournalStatValueAction,
  GetJournalAction,
  LoadReviewTypeAction,
  LoadReviewsAction,
  LoadReviewAction,
  CreateReviewAction,
  EditReviewAction,
  RemoveReviewAction,
  GetUserLocations,
  LoadChatroomDialoguesAction,
  CreateChatroomDialogueAction,
  AddDialogueToFavoritesAction,
  RemoveDialogueFromFavoritesAction,
  GetCmFilters,
  GetCmCountyFilters,
  GetCmServices,
  GetCmService,
  AddCmServiceFavorite,
  RemoveCmServiceFavorite,
  LoadReferrelsAction,
  AddReferral,
  RemoveReferral,
  SendReferralsAction,
  GetCmServicesOrg,
  LoadSearchDialoguesAction,
  CreateSearchDialogueAction,
  EditSearchDialogueAction,
  RemoveSearchDialogueAction,
  LoadSearchDialogueAction,
  LoadTrainingDialoguesAction,
  CreateTrainingDialogueAction,
  EditTrainingDialogueAction,
  RemoveTrainingDialogueAction,
  LoadTrainingDialogueAction,
  LoadExerciseToDoAction,
  LoadExerciseDoneAction,
  LoadExerciseDialogueAction,
  LoadExerciseStatisticsAction,
  LoadStatisticsDashboardAsyncAction,
  LoadUserGroupsAction,
  SendVerificationEmailAction,
  GetVideoAvatarAction,
  UpdateUserVideoAvatarAction,
  LoadSessionsAction,
  RemoveSessionDialogueAction,
  LoadActivitiesAction,
  LoadActivityJournalsAction,
  RemoveActivityDialogueAction,
  GetFavoriteNewItems,
  LoadNotificationsAction,
  MarkNotificationReadAction,
  MarkAllNotificationsReadAction,
  GetNotificationCountAction,
  LoadPatientAssignmentsAction,
  LoadPatientRunAction,
  LoadPatientLibraryAction,
  LoadPatientMedicationsAction,
  LoadPatientCareTeamAction,
  LoadAssistantSessionAction,
  LoadProgramDetailAction,
  LoadProgramNextAction,
  LoadProgramModulesAction,
  LoadProgramLibraryAction,
  LoadProgramCareTeamAction,
  LoadStepContentAction,
  SubmitStepAction,
  SaveStepDraftAction
}
